import { CloseCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import {
    Button,
    Col,
    Form,
    Image,
    Input,
    Row,
    Select,
    Tabs,
} from "antd";
import { useState } from "react";
import MainLayout from "./../../../components/mainLayout";
import "./Banner.scss";
import UploadMultiple from './../../../commons/UploadMultiple/UploadMultiple';
import BlockForm from './../../../components/form/blockForm';
import { authApis } from "./../../../services/authApi";
import { nofication } from './../../../commons/Nofication';
import { useParams } from 'react-router-dom';
import { ROOT_URL } from "../../../constants/api";
import BackButton from "../../../commons/BackButton";

const { TabPane } = Tabs;
const style = { padding: "8px 20px" };
const onChange = (key) => {
    console.log(key);
};

const Register = () => {
    const [fileList, setFileList] = useState([]);
    const [imageUrl, setImageUrl] = useState([]);
    const [idsRemove, setIdsRemove] = useState([]);
    const [imgCurrent, setImgCurrent] = useState([]);
    
    const [form] = Form.useForm();
    let { id } = useParams();
    const [content, setContent] = useState({
        content_vi: "",
        content_en: "",
        content_kr: "",
    });
    const onChangeContentValue = (lang) => {
        console.log('lang')
    }
    useState(() => {
        // if (id) {
            authApis
                .getDetailBanner(1)
                .then((data) => {
                    if (data.status_code === 200) {
                        form.setFieldsValue(data.banner)
                        setImageUrl(data.images)
                        setImgCurrent(data.images)
                        setContent({
                            content_vi: data.banner?.content_vi ?? '<p></p>',
                            content_en: data.banner?.content_en ?? '<p></p>',
                            content_kr: data.banner?.content_kr ?? '<p></p>',
                        });
                    } else {
                        nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                    }
                })
                .catch((errors) => {
                    nofication('error', 'Thất bại', 'Không kết nối được server');
                    console.log(errors)
                });
        // }
    })

    const onFinish = async () => {
        const values = form.getFieldValue();
        values.logo = undefined;
        const formData = new FormData();
        for (var key in values) {
            if (key === 'content_vi' || key === 'content_en' || key === 'content_kr') {
                formData.append(key, values[key]?.editor ? values[key]?.editor.getData() : values[key]);
            } else {
                formData.append(key, values[key]);
            }
        }
        id && formData.append('id', id);
        console.log('fileList', fileList);
        if (fileList && fileList.length !== 0){
            for (let i = 0; i < fileList.length; i++) {
                formData.append('logo' + i, fileList[i])
                console.log('fileList[i]',fileList[i])
            }
        }
        formData.append('total', fileList && fileList.length)
        formData.append('idsRemove', idsRemove)
        formData.append('type', 0)
        await authApis
            .banner(formData)
            .then((data) => {
                if (data.status_code === 200) {
                    setImageUrl([...data.images])
                    setFileList([])
                    nofication('success', 'Thành công', 'Cập nhật thành công!');
                } else {
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
                console.log(errors)
            });
    };

    return (
        <MainLayout
            isShowActionHeader={false}
            title="Banner"
            link="/banner/"
            titleNew="Banner"
        >
            <Form form={form} layout="vertical" onFinish={onFinish} colon={true}>
                <Row gutter={16} style={{ minHeight: "873px" }}>
                    <Col span={24} style={{ paddingRight: "19px" }}>
                        <div className="box-class">
                            {/* <Tabs defaultActiveKey="1" onChange={onChange}>
                                <TabPane tab="Tiếng việt" key="1">
                                    <BlockForm lang={'vi'} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane>
                                <TabPane tab="Tiếng anh" key="2">
                                    <BlockForm lang={'en'} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane>
                                <TabPane tab="Tiếng hàn" key="3">
                                    <BlockForm lang={'kr'} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane>
                            </Tabs> */}
                            <Form.Item label="Banner" colon={true}>
                                <UploadMultiple imageUrl={imageUrl} setFileList={setFileList} setImageUrl={setImageUrl} setIdsRemove={setIdsRemove} idsRemove={idsRemove} imgCurrent={imgCurrent} fileList={fileList} span={24} />
                            </Form.Item>
                            <Form.Item>
                                <Row
                                    justify="space-between"
                                    style={{ marginTop: 30 }}
                                >
                                    <Col>
                                        <Button
                                            type="primary"
                                            icon={<ReloadOutlined />}
                                            htmlType="submit"
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            htmlType="reset"
                                            style={{
                                                background: "#6c757d",
                                                color: "white",
                                                marginLeft: 20,
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </Col>
                                    <Col>
                                        <BackButton />
                                    </Col>
                                </Row>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
            </Form>
        </MainLayout>
    );
};

export default Register;
